// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"657":"a38dc151","877":"7005c1c3"}[chunkId] + ".css";
};